export enum UrlSearchParamKey {
  ADDRESS = "address",
  PAGE = "page",
  TAB = "tab",
  BRIDGE = "bridge",
  SOURCE_CHAIN = "source_chain",
  TARGET_CHAIN = "target_chain",
  SOURCE_TOKEN = "source_token",
  TARGET_TOKEN = "target_token",
  TOKEN_CATEGORY = "token_category",
}
